const facetimeReward = (data) => {
  const retData = data;
  return new Promise((resolve, reject) => {
    window.HiyaJSBridge.callHandler("facetimeReward", retData, (res) => {
      const { status } = res;
      if (status === 1) {
        resolve(status);
      }
      reject(status);
    });
  });
};
export {
  facetimeReward
};
